import { customFetch } from 'utils/http';
import { processChangePasswordResponse } from 'services/production/utils/processChangePasswordResponse';
import { getM8UserURL } from 'services/production/utils/getM8URL';

type Params = {
  oldPassword: string;
  newPassword: string;
};

export const changeClientPassword = async (params: Params) => {
  const { oldPassword, newPassword } = params;

  const fetchURL = getM8UserURL('changePassword');

  const body = new FormData();

  body.append('oldPassword', oldPassword);
  body.append('newPassword', newPassword);

  const response = await customFetch(fetchURL, { method: 'POST', body });

  await processChangePasswordResponse(response);
};
